import './index.scss';
import HomePage from './components/HomePage.js'
import TutorsListPage from './components/TutorsListPage.js'
import TutorProfilePage from './components/TutorProfilePage.js'
import BookingPage from './components/BookingPage.js'
import SuccessPage from './components/SuccessPage.js'
import {Routes, Route} from 'react-router-dom';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/tutors-list-page" element={<TutorsListPage/>} />
        <Route path="/tutor-profile-page" element={<TutorProfilePage/>} />
        <Route path="/booking-page" element={<BookingPage/>} />
        <Route path="/success-page" element={<SuccessPage/>} />
      </Routes>
    </div>
  );
}

export default App;